import { render, staticRenderFns } from "./background.vue?vue&type=template&id=4f6ca7ca&scoped=true&"
import script from "./background.vue?vue&type=script&lang=js&"
export * from "./background.vue?vue&type=script&lang=js&"
import style0 from "./background.vue?vue&type=style&index=0&id=4f6ca7ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6ca7ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f6ca7ca')) {
      api.createRecord('4f6ca7ca', component.options)
    } else {
      api.reload('4f6ca7ca', component.options)
    }
    module.hot.accept("./background.vue?vue&type=template&id=4f6ca7ca&scoped=true&", function () {
      api.rerender('4f6ca7ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/webPage/background.vue"
export default component.exports